<template>
  <div>
    <v-list nav dense>
      <v-subheader>Admin</v-subheader>
      <ferro-menu-item
        title="Admin Dashboard"
        icon="mdi-shield-account"
        :route-name="ROUTES.ADMIN_DASHBOARD"
      />
      <ferro-menu-item
        title="Accounts"
        icon="mdi-folder-account"
        :route-name="ROUTES.ADMIN_ACCOUNTS"
      />
      <ferro-menu-item
          v-if="isInAccountContext"
          title="This Account" icon="mdi-format-list-bulleted"
          :route-name="ROUTES.ACCOUNT_DETAILS"
      />
    </v-list>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as routes from '@/router/route-names'
import FerroMenuItem from '@/components/sidemenu/FerroMenuItem'

export default {
  components: { FerroMenuItem },
  created() {
    this.ROUTES = routes
  },
  computed: {
    ...mapGetters({
      getActiveAccount: 'getActiveAccount',
    }),
    isInAccountContext() {
      if (!this.getActiveAccount) {
        return false
      }
      return !!this.getActiveAccount.accountCode
    },
    accountCode() {
      if (this.getActiveAccount) {
        return this.getActiveAccount.accountCode
      }
      return undefined
    },
  },
  methods: {
    ...mapActions({
      setActiveAccount: 'setActiveAccount',
      setAdminAccountView: 'setAdminAccountView',
      logout: 'logout',
    }),
    goTo(page) {
      this.$router
        .push({
          name: page,
          params: { accountId: this.accountCode },
        })
        .catch(() => {})
    },
  },
}
</script>
